import React from "react";
import EditableTable from "../../../../primer/Editable-Table";
import {
    prescriptionDoseAmountOptions,
    prescriptionFrequencyOptions,
    prescriptionParticipationPercentageOptions
} from "../constants";

const IFETDrugTable = ({data, onUpdate, daysAmount}) => {
    const tableColumns = [
        {
            name: "Δραστική Ουσία",
            field: "erp_active_substance",
            editable: true,
            inputType: {
                type: "input",
            }
        },
        {
            name: "Μορφή",
            field: "erp_form",
            editable: true,
            inputType: {
                type: "input",
            }
        },
        {
            name: "Περιεκτικότητα",
            field: "erp_content",
            editable: true,
            inputType: {
                type: "input",
            }
        },
        {
            name: "% Συμμετοχή",
            field: "erp_participationPercentage",
            editable: true,
            inputType: {
                type: "select",
                options: prescriptionParticipationPercentageOptions,
            }
        },
        {
            name: "Ποσό Δόσης",
            field: "erp_doseAmount",
            editable: true,
            inputType: {
                type: "select",
                options: prescriptionDoseAmountOptions,
            }
        },
        {
            name: "Μονάδα Δόσης",
            field: "erp_doseUnit",
            editable: true,
            inputType: {
                type: "input",
            }
        },
        {
            name: "Συχνότητα",
            field: "erp_frequency",
            editable: true,
            inputType: {
                type: "select",
                options: prescriptionFrequencyOptions,
            }
        },
        {
            name: "Ημέρες",
            field: "erp_days",
            editable: true,
            inputType: {
                type: "select",
                options: daysAmount,
            }
        },
        {
            name: "Σχόλια",
            field: "erp_notes",
            editable: true,
            inputType: {
                type: "input",
            }
        }
    ];

    return (
        <React.Fragment>
            <EditableTable
                tableName={"IFET Drug Table"}
                key={Math.random()}
                columns={tableColumns}
                onUpdate={onUpdate}
                data={data}
                allowInsertRow={true}
                allowActions={true}
            />
        </React.Fragment>
    )
}

export default IFETDrugTable;
